module.exports = __webpack_public_path__ + "assets/loop-preview-list.161152aa.svg";